import useSWR from 'swr';
import {isEntitled} from '../reducers/user';
import axiosInstance from './axios';

export const fixHouseholdType = type => ['FIRM_HOUSEHOLD', 'BRANCH_HOUSEHOLD', 'ADVISOR_HOUSEHOLD'].includes(type)
  ? 'HOUSEHOLD'
  : type;

const typesFetcher = url => axiosInstance.get(url)
  .then(res => res.data.map(item => ({label: item, value: item})));

export const getHoldingsTypes = ({con, options}) => useSWR(
  con && con.id && `/containers/${con.id}/securities/types`,
  typesFetcher,
  options
);

export const getTransactionTypes = ({con, options}) => useSWR(
  con && con.id && `/containers/${con.id}/transactions/types`,
  typesFetcher,
  options
);

const institutionsFetcher = url => axiosInstance.get(url)
  .then(res => {
    const institutions = res.data;
    const unknownInstitution = {
      name: 'Unknown',
      balance: 0,
      balancePercent: 0,
      accountCounts: {
        total: 0,
        new: 0,
        rebalancing: 0,
      },
    };

    for (let i = institutions.length - 1; i >= 0; i--) {
      if (!institutions[i].name) {
        unknownInstitution.balance += institutions[i].balance;
        unknownInstitution.balancePercent += institutions[i].balancePercent;
        unknownInstitution.accountCounts.total += institutions[i].accountCounts.total;
        unknownInstitution.accountCounts.new += institutions[i].accountCounts.new;
        unknownInstitution.accountCounts.rebalancing += institutions[i].accountCounts.rebalancing;
        institutions.splice(i, 1);
      }
    }

    if (unknownInstitution.accountCounts.total) {
      institutions.push(unknownInstitution);
    }
    return institutions.map(i => ({
      ...i,
      label: i.name,
      value: i.name,
      subLabel: `Accounts: ${(i.accountCounts.total)}`,
    }));
  });

export const getInstitutions = ({con, options}) => useSWR(
  isEntitled([{group: 'account', feature: 'institution', access: 'r'}]) && con && con.id && `/containers/${con.id}/institutions`,
  institutionsFetcher,
  options
);

// ETODO This 'could' change the number of hooks and refresh and is BAD. the better approch is to have 1 useSWR that is always executed but passed didn't urls conditionally
export const getCounts = ({session, options}) => {
  if (session.profile.role === 'FIRMMGR' || session.profile.role === 'CPLO') {
    return useSWR(
      session && session.profile && `/firms/${session.profile.firm.id}/counts`,
      options
    );
  }
  if (session.profile.role === 'BRANCHMGR') {
    return useSWR(
      '/crm/branches/counts',
      options
    );
  }
  if (session.profile.role === 'ADVISOR') {
    return useSWR(
      session && session.profile && `/crm/advisors/${session.profile.id}/counts`,
      options
    );
  }
};
